import { NAME_COMPARISON_OPERATOR } from "../constants/shiftConsts";

export const compareConditions: any = {
    [NAME_COMPARISON_OPERATOR.NHO_HON]: (a: number, b: number) => Number(a) < Number(b),
    [NAME_COMPARISON_OPERATOR.NHO_HON_BANG]: (a: number, b: number) => Number(a) <= Number(b),
    [NAME_COMPARISON_OPERATOR.LON_HON]: (a: number, b: number) => Number(a) > Number(b),
    [NAME_COMPARISON_OPERATOR.LON_HON_BANG]: (a: number, b: number) => Number(a) >= Number(b),
    [NAME_COMPARISON_OPERATOR.BANG]: (a: number, b: number) => Number(a) === Number(b),
};
